var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtsyProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4838c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28539,
    stopColor: "#f46a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#f45800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2900"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.83099,65.96814l-1.23199,2.72485c-.91663,2.14722-2.38721,2.26721-3.85913,2.26721h-4.76324c-1.58075,0-2.26721-.57764-2.26721-1.92957v-7.03046s3.40155,0,4.53442.12c.90552.10883,1.36316.33899,1.70074,1.47192l.33765,1.59192h1.36316l-.12-4.07678.22882-3.97913h-1.35199l-.45764,1.82074c-.22882,1.24316-.45758,1.3631-1.70074,1.58075-1.58075.12-4.53442.12-4.53442.12v-8.38239c0-.34882,0-.45764.57764-.45905h7.12811c1.25287,0,1.92957,1.01434,2.37604,3.05273l.45764,1.59192h1.2431c.12-4.53442.22882-6.45282.22882-6.45282,0,0-3.05133.32648-4.8609.32648h-9.06885l-4.76324-.09766v1.2431l1.58075.33484c1.1441.22882,1.48175.45764,1.48175,1.47198,0,0,.12,3.06384.12,8.15356,0,5.10229-.12,8.16479-.12,8.16479,0,.90546-.33765,1.2431-1.48175,1.47192l-1.58075.34882v1.23193l4.87207-.10883h8.16473c1.80957,0,6.11523.10883,6.11523.10883.10883-1.12311.67523-6.11517.79523-6.68164h-1.14404Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.31812,36.8147l-5.6098-3.23883-18.48682,10.67346,6.79388,3.9223c.36639.21155.81787.21155,1.18433,0l16.11841-9.30554c.78955-.45587.78955-1.59552,0-2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.01562,27.50891l-16.11823,9.30585c-.78961.45587-.78961,1.59552,0,2.05139l5.13184,2.96283,18.48712-10.67334-6.31641-3.64673c-.36639-.21161-.81787-.21161-1.18433,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.02496,43.4646v18.68835c0,.41119.21936.7912.5755.99677l16.18451,9.34412c.76733.44305,1.7265-.11072,1.7265-.99677v-18.68817c0-.41125-.21936-.7912-.5755-.99683l-6.87177-3.96753v9.87964l-4.19208-2.17682v-10.12317l-5.12067-2.95642c-.76733-.44305-1.7265.11072-1.7265.99683Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtsyProductsScraper);
export default __webpack_public_path__ + "static/media/etsy-products-scraper.30ab3cd04a0f6a9c2be6434040a58612.svg";
export { ForwardRef as ReactComponent };